var _excluded = ["appearance"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { HeroImage } from './hero-image';
import { jsx as ___EmotionJSX } from "@emotion/core";
var HeroComponents = {
  image: HeroImage
};
var defaultComponent = HeroComponents.image;
var getComponent = function getComponent() {
  var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'image';
  return HeroComponents[appearance] || defaultComponent;
};
export var Hero = _ref => {
  var appearance = _ref.appearance,
    props = _objectWithoutProperties(_ref, _excluded);
  var HeroComponent = getComponent(appearance);
  return ___EmotionJSX(HeroComponent, props);
};